import React, { useState } from "react";
import { PenLine } from "lucide-react";
import { useLocalization } from "../hooks/useLocalization";

export const SignaturePanel = ({ onSign, label }) => {
  const { t } = useLocalization();
  const [typedName, setTypedName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!typedName.trim()) return;
    setSubmitting(true);
    try {
      await onSign(typedName.trim());
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rounded-xl border border-gray-200 p-5 bg-white" data-testid="signature-panel">
      <div className="flex items-center gap-2 mb-3">
        <PenLine className="text-blue-600" size={18} />
        <p className="text-sm font-semibold text-gray-800">{label}</p>
      </div>
      <input
        data-testid="signature-typed-name-input"
        value={typedName}
        onChange={(e) => setTypedName(e.target.value)}
        placeholder={t("contracts.typedName")}
        className="w-full px-4 py-2.5 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 mb-3"
      />
      <button
        data-testid="signature-submit-button"
        disabled={!typedName.trim() || submitting}
        onClick={handleSubmit}
        className="w-full py-2.5 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 active:scale-95 transition-all disabled:opacity-40"
      >
        {submitting ? t("common.loading") : t("common.submit")}
      </button>
    </div>
  );
};
